import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82b53894"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Hedge Fund Platforms & Prime Brokers", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Calculate. Integrate. Evaluate.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "two-thirds" }, [
    /*#__PURE__*/_createTextVNode("From initial analysis"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("to final attribution.")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns right" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "static" }, "Derivitec products have been designed to allow users to understand the risk on their portfolios clearly, and effectively. Available out of the box as a powerful web application, or integrated directly into the client’s own applications, Derivitec covers your risk needs from initial analysis to final attribution, providing complete transparency across all stakeholders in your organisation.")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Features & Benefits", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Calculate", -1))
const _hoisted_7 = { class: "columns" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Hosted natively in the cloud, Derivitec risk engines will automatically scale out to handle the complexity of your requirements. With industry standard models and a 24-7 market data process running in the background, Derivitec can calculate arbitrarily complex reports across all major asset classes.")
], -1))
const _hoisted_9 = { class: "half" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Find Out More", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Derivitec runs a 24-7 market data process, gathering raw data from multiple sources, including Thomson Reuters and Xignite, and then converting that data into model ready ‘derived data’ objects (yield curves, vol surfaces etc). With coverage across equities, foreign exchange, interest rates, commodities, credit and fixed income, Derivitec supplies end of day data at no extra cost, allowing you to calculate the risk on your portfolio, no matter how complex the asset class make-up.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "With an aggregate of decades of experience building pricing and risk models for tier one investment banks, Derivitec are recognised experts in derivatives modeling. All of our models are mark-to-market, where possible, and rigorously tested with the same attention to detail as a leading investment bank or hedge fund.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "From day one, Derivitec built to scale. Hosted in Amazon Web Services powerful elastic compute architecture, Derivitec resources scale to meet demand, as rapidly as demand ramps up. We can thereby calculate the many risks you may want to look at, no matter how complex and large the calculation may be.", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Derivitec believes that effective risk management is all about having as many views as you need to make informed decisions. In addition to a powerful suite of standard reports covering end of day risk, collateral risk, profit and loss attribution, and value-at-risk, Derivitec builds reports to fit your needs, together with any treatment bespoke to your organisation.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Features & Benefits", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Integrate", -1))
const _hoisted_17 = { class: "columns" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
  /*#__PURE__*/_createElementVNode("p", null, "We supply APIs to support every part of your process, from the initial order to final PnL attribution, enabling you to leverage the power of our data and analytics on top of your existing workflow systems with minimal integration cost.")
], -1))
const _hoisted_19 = { class: "half" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Find Out More", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Our APIs can plug directly into the code of your preferred order management system, allowing for real time updates of your positions, exactly reconciled to your books and records.", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Through a process of market data overrides against our end of day derived data, Derivitec can integrate with your third-party live data feeds, enabling real time calculation of your risk, viewable through in house applications and the Derivitec Risk Portal itself.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Derivitec can both source data and supply data through our API. We can integrate our cloud-based pricing architecture directly into your preferred portfolio management system, allowing you to combine our risk capabilities in a single workflow application.", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Features & Benefits", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Evaluate", -1))
const _hoisted_26 = { class: "columns" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Available out of the box through our award-winning Risk Portal, or through Python integration, you can drill into your risk numbers, both pre and post trade, in as much detail as you require. Our APIs also allow you to prepare white labelled risk reports for your own stakeholders. Complete transparency, exactly the way you want it.")
], -1))
const _hoisted_28 = { class: "half" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Find Out More", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "With our Python APIs, you can source whatever information you need to build informed, pre-trade analysis. How much would this product cost to hedge if the market evolved under current conditions? What would be the effect on my risk limits if I put this on? Can I hedge this product better? Our APIs allow you to combine the limitless flexibility of the Python data framework with exactly the data and numbers you need to make these, and any other key pre-trade decisions", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The Derivitec Risk Portal is a great place to run risk reports, but wouldn’t you also like something which has exactly the look and feel of your company? Derivitec is happy to work with you to combine our own API functionality with proprietary data and your own preferred data representations to create something which adds value for both you and your stakeholders.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_collapsible = _resolveComponent("collapsible")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, null, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "calculate" }, {
      default: _withCtx(() => [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_collapsible, { heading: "Market Data" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_collapsible, { heading: "Models" }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_collapsible, { heading: "Compute" }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _createVNode(_component_collapsible, { heading: "Reporting" }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_panel, null, {
      default: _withCtx(() => [
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_collapsible, { heading: "Order Management" }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }),
            _createVNode(_component_collapsible, { heading: "Live Data" }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            }),
            _createVNode(_component_collapsible, { heading: "Portfolio Management" }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "evaluate" }, {
      default: _withCtx(() => [
        _hoisted_24,
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode(_component_collapsible, { heading: "Pre-trade" }, {
              default: _withCtx(() => [
                _hoisted_30
              ]),
              _: 1
            }),
            _createVNode(_component_collapsible, { heading: "White labelling" }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}